/*
 * @Author: 孙照
 * @LastEditTime: 2023-04-20 16:53:24
 * @Description: vuex 状态管理
 * @FilePath: \monitor\fuzhou\src\store\index.js
 */
import Vue from 'vue';
import Vuex from 'vuex';
import global from './modules/global';
import overView from './modules/overView';
import charging from './modules/chargingStat';
import batterySwap from './modules/batteryReplace';

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {},
  actions: {},
  mutations: {},
  modules: {
    global,
    overView,
    charging,
    batterySwap,
  },
});

export default store;
